/**
 * @fileoverview お知らせ・注意事項等のメッセージを表示する際のセクショニングコンポーネント
 */
<script lang="ts">
import { defineComponent, PropType } from 'vue'

const MESSAGE_STATUSES = ['info', 'notice', 'success', 'warning', 'alert'] as const
type MessageStatus = typeof MESSAGE_STATUSES[number]

export default defineComponent({
  name: 'MessageSection',

  props: {
    status: {
      type: String as PropType<MessageStatus>,
      default: 'notice',
      validator: (value: string) => MESSAGE_STATUSES.includes(value as MessageStatus),
    },

    slim: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<template>
  <section
    class="f-section__message"
    :data-status="status"
    :data-slim="slim">
    <div class="f-section__message--body">
      <div class="l-unit__messageSection">
        <div
          v-if="$slots.header"
          class="l-unit__messageSection--header">
          <slot name="header" />
        <!-- /.l-unit__messageSection header --></div>

        <div
          v-if="$slots.description"
          class="l-unit__messageSection--description">
          <slot name="description" />
        <!-- /.l-unit__messageSection description --></div>
      <!-- /.l-unit__messageSection --></div>
    <!-- /.f-section__message body --></div>
  <!-- /.f-section__message --></section>
</template>

<style lang="sass" scoped>
// foundation
.f-section__message
  $root: &
  width: 100%
  margin: 1.5em auto 1em
  border:
    width: 1px
    style: solid
  border-radius: $border-radius

  &:first-child
    margin-top: 0

  &:last-child
    margin-bottom: 0

  &[data-status="info"]
    background-color: rgba($bg-x-light-gray, 1)
    border-color: $border-light-gray

  &[data-status="notice"]
    background-color: rgba($bg-notice, 1)
    border-color: $border-notice

  &[data-status="success"]
    background-color: rgba($bg-success, 1)
    border-color: $border-success

  &[data-status="alert"]
    background-color: rgba($bg-alert, 1)
    border-color: $border-alert

  &[data-status="warning"]
    background-color: rgba($bg-warning, 1)
    border-color: $border-warning

  &[data-slim="true"]
    #{$root}--body
      padding: 0.5em

  & &--body
    padding: 1em

// layout
.l-unit__messageSection
  & &--description
    margin-top: 0.5em

    &:first-child
      margin-top: 0
</style>
